import { render, staticRenderFns } from "./TroveFooter.vue?vue&type=template&id=2d98ad80&scoped=true&"
import script from "./TroveFooter.vue?vue&type=script&lang=js&"
export * from "./TroveFooter.vue?vue&type=script&lang=js&"
import style0 from "./TroveFooter.vue?vue&type=style&index=0&id=2d98ad80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d98ad80",
  null
  
)

export default component.exports